import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import DashboardClientsPersonTableRowData from './table-row'
import { ToastContainer } from 'react-toastify'
import { subtractDeletionArray, appendDeletionArray, resetPersonClientsList, retrievePersonClientsList } from '../../../../../redux/actions/clients'
import { Checkbox } from '../../../../library/checkbox'
import './style.scss'

const Index = ({searchQuery}) => {

    const dispatch = useDispatch()
    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
    const loading = useSelector(state => state.clients.fetchPersonClients.loading)
    const people = useSelector(state => state.clients.personClients)
    const userLoading = useSelector(state => state.user.fetchUserDetails.loading)

    const deletions = useSelector(state => state.clients.deletionArray)
    const [allSelected, setAllSelected] = useState(false)

    const clickSelectAll = e => {
        if(e.target.checked){
            setAllSelected(true)
            for(var clientItem in people){
                if(!deletions.includes(people[clientItem].id)){
                    dispatch(appendDeletionArray(people[clientItem].id))
                }
            }
        } else {
            setAllSelected(false)
            for(var clientItem in people){
                if(deletions.includes(people[clientItem].id)){
                    dispatch(subtractDeletionArray(people[clientItem].id))
                }
            }
        }
    }

    useEffect(() => {

        if(!userLoading){
            if(selectedCompany){
                dispatch(resetPersonClientsList())
                dispatch(retrievePersonClientsList({companyId: selectedCompany}))
            } else {
                if(!userLoading && !loading){
                    dispatch(resetPersonClientsList())
                }
            }
        }
				
    }, [selectedCompany, userLoading]);


    if(!loading)
    return(
        <section className="all-person-clients-section">
            <div className="inner-all-person-clients-container">
				<ToastContainer/>
                <table className="clients-person-table">
                    <thead>
                    <tr>
                        <th><Checkbox onClick={(e) => clickSelectAll(e)} checked={allSelected} type="checkbox" id="select"/></th>
                        <th>FULLT NAVN</th>
                        <th>DATO OPPRETTET</th>
						<th>LAGT TIL AV</th>
                        <th>HANDLING</th>
                    </tr>
                    </thead>
                    <tbody>
                    {people.map((singleClient, index, arr) => {
                        if(!searchQuery){
                            return(<DashboardClientsPersonTableRowData singleClient={singleClient} index={index} arr={arr}/>)
                        } else {
                            if(singleClient.name.toLowerCase().includes(searchQuery.toLowerCase())){
                                return(<DashboardClientsPersonTableRowData singleClient={singleClient} index={index} arr={arr}/>)
                            }
                        }
                    })}
                    </tbody>
                </table>
            </div>
        </section>
    )

    return null
}

export default Index;
